<template lang="pug">
y-dialog(v-model="showDialog" :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600" persistent scrollable content-class="round-3xl")
  v-card
    v-card-title.px-4.py-3
      v-card-title.px-4
      v-spacer
      .text-xl.font-bold.ml-10.text-capitalize {{ $t('import_csv') }}
      v-spacer
      v-btn(icon @click="showDialog = false")
        v-icon mdi-close
    v-divider
    
    .px-6
      v-tabs(v-model="currentTab")
        v-tab
          v-icon.mr-4(color="success" v-if="currentTab > 0") $yzi-check-circle
          .text-sm.text-none.font-medium 1. {{ $t('upload_csv') }}
        v-tab(:class="{ 'tab-disabled': currentTab < 1 }")
          v-icon.mr-4(color="success" v-if="currentTab > 1") $yzi-check-circle
          .text-sm.text-none.font-medium 2. {{ $t('map_fields') }}
        v-tab(:class="{ 'tab-disabled': currentTab < 2 }")
          .text-sm.text-none.font-medium 3. {{ $t('review') }}
      v-divider

    v-card-text.px-6
      v-tabs-items(v-model="currentTab")
        v-tab-item
          .pt-6
            .text-sm.mb-2 {{ $t('upload_csv_file_containing_users') }}
            v-form(ref="form")
              .d-flex.my-4.align-center
                v-file-input.round-xl.mr-2(dense v-model="inputFile" outlined show-size accept=".csv" prepend-icon :placeholder="$t('choose_a_file')" hide-details="auto" :rules="rules.size")
                v-btn.button-sm(depressed color="#EEEEEE" @click="browseFile") {{ $t('browse') }}
                input.d-none(type="file" accept=".csv" @change="onIncomeFileChange" ref="uploadInput")
            .text-xs.mb-2.neutral500--text.pb-8 *  {{ $t('maximum_file_size_1mb') }}
            .text-right
              v-btn.button-md(@click="mapCsv" color="primary" depressed :disabled="!inputFile" :loading="isMapping") {{ $t('next') }}
        v-tab-item
          template(v-if="mappingResponse && inputFile")
            map-invitation-fields(:data="mappingResponse" :inputFile="inputFile" :os="os" @onValidate="onValidate" @onMapping="onMapping")  
        v-tab-item
          review-import-invitation(:data="validateResponse" :inputFile="inputFile" :mapperFormData="mapperFormData" @onComplete="onComplete" @onReupload="onReupload")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MapInvitationFields from '@/components/review/general/MapInvitationFields.vue'
import ReviewImportInvitation from '@/components/review/general/ReviewImportInvitation.vue'

export default {
  name: 'ImportInvitationDialog',
  components: {
    MapInvitationFields, ReviewImportInvitation
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    os: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      currentTab: 0,
      inputFile: null,
      isMapping: false,
      mappingResponse: null,
      validateResponse: null,
      mapperFormData: null,
      rules: {
        size: [value => !value || value.size < 1000000 || 'File size should be less than 1 MB']
      }
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    }
  },
  mounted () {
    this.headers?.map(item => item['class'] = 'text-table-header')
  },
  methods: {
    ...mapActions(['showMessage']),
    closeDialog() {
      this.showDialog = false
    },
    browseFile() {
      this.$refs.uploadInput.click()
    },
    onIncomeFileChange(e) {
      this.inputFile = null
      const files = e.target.files || e.dataTransfer.files
      if (files.length) {
        this.inputFile = files[0]
      }
    },
    mapCsv() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isMapping = true
      const params = new FormData()
      params.append('file', this.inputFile)
      this.$axios.post(`/reviews/${this.company.slug}/invites/mapping_csv`, params)
        .then(resp => {
          this.processMappingResponse(resp.data)
        })
        .catch(e => {
          if (e?.response?.data?.file?.length > 0) {
            this.showMessage(['error', e.response.data.file[0]])
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_import_csv')])
          }
        })
        .finally(() => {
          this.isMapping = false
        })
    },
    processMappingResponse(response) {
      this.mappingResponse = response
      const rowLength = response.data[0].length
      if (rowLength <= 1) {
        this.showMessage(['error', 'Row data is empty'])
      } else {
        this.currentTab = 1
      }
    },
    onValidate(response) {
      this.validateResponse = response
      this.currentTab = 2
    },
    onMapping(response) {
      this.mapperFormData = response
    },
    onReupload() {
      this.inputFile = null
      this.currentTab = 0
    },
    onComplete() {
      this.$emit('onComplete')
      this.showDialog = false
    }
  }
}
</script>
